import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface Crumb {
  label: string;
  to?: string;
}
interface PageHeaderProps {
  title: string;
  intro?: ReactNode;
  crumbs: Crumb[];
  children?: ReactNode;
}
export function PageHeader({
  title,
  intro,
  crumbs,
  children
}: PageHeaderProps) {
  return <section className="border-b border-line bg-surface" data-id="element-260" data-mp="3mdoif6fd6kpw">
      <div className="mx-auto max-w-7xl px-5 pb-14 pt-10 lg:px-8 lg:pb-16 lg:pt-12" data-id="element-261" data-mp="2yqq5ujud7wx9">
        <nav aria-label="Kruimelpad" data-id="element-262" data-mp="2trwpmjnp1rte">
          <ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted" data-id="element-263" data-mp="2toqzr278qlwm">
            <li data-id="element-264" data-mp="38haylqncy789">
              <Link to="/" className="hover:text-primary" data-id="element-265" data-mp="38hujng8b1bqi">
                Home
              </Link>
            </li>
            {crumbs.map(crumb => <li key={crumb.label} className="flex items-center gap-1.5" data-id="element-266" data-mp="2fyf62yv0cf3d">
                <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-267" data-mp="2b0m3efswy37u" />
                {crumb.to ? <Link to={crumb.to} className="hover:text-primary" data-id="element-268" data-mp="2hzrocj1tiyno">
                    {crumb.label}
                  </Link> : <span aria-current="page" className="text-ink" data-id="element-269" data-mp="2lygz03vh223m">
                    {crumb.label}
                  </span>}
              </li>)}
          </ol>
        </nav>
        <h1 className="mt-6 max-w-3xl font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl" data-id="element-270" data-mp="2vsh9kl9ivzjq">{title}</h1>
        {intro && <div className="mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-271" data-mp="231fv6mdnm819">{intro}</div>}
        {children}
      </div>
    </section>;
}